import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useAuth } from "@clerk/react";
import { publicGet, useApi } from "@/lib/api";

const MeCtx = createContext(null);

export function MeProvider({ children }) {
  const { isSignedIn, isLoaded } = useAuth();
  const api = useApi();
  const [me, setMe] = useState(null);
  const [config, setConfig] = useState(null);

  const refresh = useCallback(async () => {
    if (!isSignedIn) return setMe(null);
    try {
      setMe(await api("get", "/me"));
    } catch {
      setMe(null);
    }
  }, [isSignedIn, api]);

  useEffect(() => {
    if (isLoaded) refresh();
  }, [isLoaded, refresh]);

  useEffect(() => {
    publicGet("/public/config").then(setConfig).catch(() => {});
  }, []);

  return <MeCtx.Provider value={{ me, refresh, config, isSignedIn, isLoaded }}>{children}</MeCtx.Provider>;
}

export const useMe = () => useContext(MeCtx);
